import { render, staticRenderFns } from "./VlContactData.vue?vue&type=template&id=3d23eef2&scoped=true&"
import script from "./VlContactData.vue?vue&type=script&lang=js&"
export * from "./VlContactData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23eef2",
  null
  
)

export default component.exports